"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lab = require("@material-ui/lab");

var _icons = require("@material-ui/icons");

var _AlertTitle = _interopRequireDefault(require("@material-ui/lab/AlertTitle"));

var _styles = _interopRequireDefault(require("./styles"));

var _excluded = ["id", "className", "iconMapping", "title", "children", "alignAction"];
var defaultIconMapping = {
  success: /*#__PURE__*/_react.default.createElement(_icons.CheckCircle, {
    fontSize: "inherit"
  }),
  warning: /*#__PURE__*/_react.default.createElement(_icons.Warning, {
    fontSize: "inherit"
  }),
  error: /*#__PURE__*/_react.default.createElement(_icons.Error, {
    fontSize: "inherit"
  }),
  info: /*#__PURE__*/_react.default.createElement(_icons.Info, {
    fontSize: "inherit"
  })
};

var Alert = function Alert(props) {
  var id = props.id,
      className = props.className,
      iconMapping = props.iconMapping,
      title = props.title,
      children = props.children,
      alignAction = props.alignAction,
      otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classes = (0, _styles.default)(props);
  return /*#__PURE__*/_react.default.createElement(_lab.Alert, (0, _extends2.default)({
    id: id,
    className: (0, _classnames.default)("prmbl-alert", className, classes.root),
    classes: {
      root: classes.root,
      icon: classes.icon,
      message: classes.message,
      action: classes.action
    },
    iconMapping: iconMapping ? iconMapping : defaultIconMapping
  }, otherProps), title && /*#__PURE__*/_react.default.createElement(_AlertTitle.default, null, title), children);
};

Alert.defaultProps = {
  alignAction: "flex-start"
};
var _default = Alert;
exports.default = _default;